export const CONTRACTOR_NAME_MIN_LENGTH = 1;
export const CONTRACTOR_NAME_MAX_LENGTH = 100;
export const CONTRACTOR_CORPORATION_MIN_LENGTH = 1;
export const CONTRACTOR_CORPORATION_MAX_LENGTH = 50;
export const CONTRACTOR_DESCRIPTION_MIN_LENGTH = 1;
export const CONTRACTOR_DESCRIPTION_MAX_LENGTH = 500;
export const CONTRACTOR_PAYMENT_RATE_MIN = 0.01;
export const CONTRACTOR_PAYMENT_RATE_MAX = 99.99;
export const CONTRACTOR_NOTES_MIN_LENGTH = 1;
export const CONTRACTOR_NOTES_MAX_LENGTH = 500;
